import React from 'react';
import GstSteps from '../GstSteps/GstSteps';
import ImageSlider from '../ImageSlider/ImageSlider';
import {gstStepsData, sliderImages} from './mockData';
import {ModalContainer, ModalContainerLft, ModalContainerRht} from './ClaimGstModal.styles';

const ClaimGstModal = ({closeModal}) => {
  return (
    <React.Fragment>
      <ModalContainer>
        <ModalContainerLft>
          <ImageSlider data={sliderImages} />
        </ModalContainerLft>
        <ModalContainerRht>
          <h3>Claim your GST on Commission in 4 steps:</h3>
          <GstSteps data={gstStepsData} />
        </ModalContainerRht>
      </ModalContainer>
    </React.Fragment>
  );
};

export default ClaimGstModal;
